import {centsToLocalizedString, toCentsFromMoney, type Money} from "../../../../lib/Money.ts";
import {BANK_ACCOUNT_BALANCE_GLA_ID} from "../../../../hooks/useGLAccounts.ts";
import {ReportRowKind, type ReportRow} from "../types/types.ts";

function centsOrZero(money: Money | null | undefined): number {
    return money == null ? 0 : toCentsFromMoney(money);
}

export function formatSignedCents(cents: number): string {
    if (cents === 0) return "0,00";
    return `${centsToLocalizedString(Math.abs(cents))} ${cents < 0 ? "D" : "C"}`;
}

export const NEW_IN_PERIOD = "nieuw";

export const DELTA_DEAD_BAND_PERCENT = 0.05;

const DELTA_PERCENT_FORMAT = new Intl.NumberFormat("nl-NL", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
    signDisplay: "always",
});

const DELTA_PERCENT_UNSIGNED_FORMAT = new Intl.NumberFormat("nl-NL", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
});

export function formatDeltaPercent(
    ratio: number | null,
    currentCents = 0,
    comparisonCents = 0,
    withArrow = false,
): string {
    if (ratio === null && currentCents === 0 && comparisonCents === 0) return "";
    if (ratio === null) return NEW_IN_PERIOD;
    if (ratio === 0) return "0%";
    if (!withArrow) return `${DELTA_PERCENT_FORMAT.format(ratio * 100)}%`;
    const arrow = ratio > 0 ? "↑" : "↓";
    return `${arrow} ${DELTA_PERCENT_UNSIGNED_FORMAT.format(Math.abs(ratio * 100))}%`;
}

export function isWithinDeltaDeadBand(ratio: number | null): boolean {
    return ratio === null || Math.abs(ratio * 100) < DELTA_DEAD_BAND_PERCENT;
}

export function kpiPopoverValue(row: ReportRow): string {
    return formatSignedCents(centsOrZero(row.signed_net));
}

export function isDrillable(row: ReportRow): boolean {
    return (
        row.kind === ReportRowKind.Account &&
        row.account?.code !== BANK_ACCOUNT_BALANCE_GLA_ID &&
        row.lines.length > 0
    );
}
